var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sharer sharer-folding",class:[
    {
      'sharer--opened': _vm.opened
    }
  ]},[_c('SharerBase',_vm._b({staticClass:"sharer__list _list"},'SharerBase',_vm.$props,false)),_c('div',{staticClass:"sharer__button",attrs:{"data-cursor":"hover"},on:{"click":_vm.toggle}},[_c('div',{staticClass:"_icon"},[_c('div',{staticClass:"_icon -share"},[_c('svg-use',{attrs:{"size":"48","icon":"share"}})],1),_c('div',{staticClass:"_icon -close"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }